// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jgFXbO {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: calc(var(--spacing-2-5, 20px) * -1);
}

.lC9qqC {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-2-5, 20px);
}

/* Ícone barcode com background */
.Ffm2wo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-4, 32px);
  height: var(--spacing-4, 32px);
  background-color: #f2f2f2;
  border-radius: var(--radius-pill, 16px);
  margin-bottom: var(--spacing-2);
}

.U9U86h {
  width: var(--spacing-2-5, 20px);
  height: var(--spacing-2-5, 20px);
  filter: brightness(0) saturate(100%) invert(28%) sepia(97%) saturate(2571%) hue-rotate(10deg) brightness(98%)
    contrast(103%);
}

/* Seção de valor */
.LHgEYk {
  margin-bottom: var(--spacing-2);
}

.ZP7O1A {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0 0 var(--spacing-0-5) 0;
}

.t8ij12 {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size, 20px);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0;
}

/* Divider */
.MDrXVI {
  width: 100%;
  height: 1px;
  background-color: #f2f2f2;
  margin: var(--spacing-3, 24px) 0;
}

/* Grid de informações */
.av47Bd {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.H8ZBhH {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  align-items: start;
}

.HDFxWD {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.U5vQ1t {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  word-break: break-all;
}

/* Footer fixo */
.oVKwRm {
  display: flex;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-2-5, 20px);
  background-color: var(--surface-neutral-white);
  flex-shrink: 0;
}

.oVKwRm button {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerReceipt/DrawerReceipt.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC;kBACgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qBAAqB;EACrB,kDAAkD;EAClD,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,OAAO;AACT","sourcesContent":[".drawerContent {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: calc(var(--spacing-2-5, 20px) * -1);\n}\n\n.scrollableContent {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--spacing-2-5, 20px);\n}\n\n/* Ícone barcode com background */\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-4, 32px);\n  height: var(--spacing-4, 32px);\n  background-color: #f2f2f2;\n  border-radius: var(--radius-pill, 16px);\n  margin-bottom: var(--spacing-2);\n}\n\n.icon {\n  width: var(--spacing-2-5, 20px);\n  height: var(--spacing-2-5, 20px);\n  filter: brightness(0) saturate(100%) invert(28%) sepia(97%) saturate(2571%) hue-rotate(10deg) brightness(98%)\n    contrast(103%);\n}\n\n/* Seção de valor */\n.valueSection {\n  margin-bottom: var(--spacing-2);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0 0 var(--spacing-0-5) 0;\n}\n\n.value {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size, 20px);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n/* Divider */\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: #f2f2f2;\n  margin: var(--spacing-3, 24px) 0;\n}\n\n/* Grid de informações */\n.infoGrid {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.gridRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  align-items: start;\n}\n\n.gridLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.gridValue {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  word-break: break-all;\n}\n\n/* Footer fixo */\n.footer {\n  display: flex;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2) var(--spacing-2-5, 20px);\n  background-color: var(--surface-neutral-white);\n  flex-shrink: 0;\n}\n\n.footer button {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawerContent": `jgFXbO`,
	"scrollableContent": `lC9qqC`,
	"iconContainer": `Ffm2wo`,
	"icon": `U9U86h`,
	"valueSection": `LHgEYk`,
	"label": `ZP7O1A`,
	"value": `t8ij12`,
	"divider": `MDrXVI`,
	"infoGrid": `av47Bd`,
	"gridRow": `H8ZBhH`,
	"gridLabel": `HDFxWD`,
	"gridValue": `U5vQ1t`,
	"footer": `oVKwRm`
};
module.exports = ___CSS_LOADER_EXPORT___;
